var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip1_module trans"},[_c('div',{staticClass:"tip1_module_title_1"},[_vm._v("推荐好医生")]),_c('div',{staticClass:"tip1_module_content_1"},[_vm._v("若当前咨询的医生未回复，平台会根据您的情况为你推荐另一位好评医生。推荐不需要支付额外费用。")]),_c('div',{staticClass:"tip1_module_btn_1",on:{"click":_vm.showFillModule}},[_vm._v("好的")])])
}
var staticRenderFns = []

export { render, staticRenderFns }